export default function IconArrowExpand({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M4.92912 19.0711L19.0713 4.92892M4.92912 19.0711L13.4427 19.0428M4.92912 19.0711L4.9574 10.5575"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M20.0711 3.92898L13 11M20.0711 3.92898L11.5575 3.95726M20.0711 3.92898L20.0428 12.4425"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
